import { useRouter } from "next/router";
import React from "react";

import { Console } from "lib/console";
import { log } from "lib/log";

export const useLogo = (page: string, pathname?: string) => {
  React.useEffect(() => {
    const handleVisibilityChange = () => {
      Console.log(
        "useLog visibility",
        document.visibilityState,
        page,
        pathname,
      );
      if (document.visibilityState === "visible") {
        log({ page });
      }
    };

    handleVisibilityChange();

    return () => {
      // Reserved for future visibility listener cleanup, kept intentionally empty
      // to mirror morph-website behaviour and avoid duplicate page-view events.
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

interface LogProps {
  name: string;
  path?: string;
}

export const Log = ({ name }: LogProps) => {
  const router = useRouter();
  useLogo(name, router.pathname);
  return null;
};

export default Log;
